import React from 'react'
import { Field } from 'redux-form'
import { SelectField } from '@foodsby/nutrient'
import { required } from 'redux-form-validators/lib'
import CreditCardDetail from './CreditCardDetail'
import { InputError } from '@foodsby/nutrient'

const BillingInfo = ({ creditCards, creditCardsError, selectedCreditCard }) => {
  return (
    <div>
      {creditCards && creditCards.length > 0 ? (
        <div className="row middle-xs">
          <div className="col-xs-12 col-md-3 start-xs end-md">
            <label htmlFor="creditCard">Choose Card *</label>
          </div>
          <div className="col-xs-12 col-md-9">
            <Field
              id="SelectedCard"
              name="SelectedCard"
              component={SelectField}
              validate={[required({ msg: `Card is required` })]}
              normalize={val => (val ? Number(val) : '')}
            >
              {creditCards && creditCards.length > 1 && (
                <option key={0} value={''}>
                  Select Credit Card
                </option>
              )}
              {creditCards.map(card => {
                return (
                  <option key={card.ccProfileId} value={card.ccProfileId}>
                    XXXX-XXXX-XXXX-{card.lastFour}
                  </option>
                )
              })}
              <option key={-1} value={-1}>
                Add New Card ...
              </option>
            </Field>
          </div>
          {selectedCreditCard === -1 && (
            <CreditCardDetail creditCards={creditCards} />
          )}
        </div>
      ) : (
        <CreditCardDetail creditCards={creditCards} />
      )}
      <InputError>{creditCardsError}</InputError>
    </div>
  )
}

export default BillingInfo
